'use client';

import { ChevronUpIcon, ChevronDownIcon } from '@radix-ui/react-icons';
import { motion } from 'framer-motion';
import * as ToggleGroup from '@radix-ui/react-toggle-group';
import styles from './scroll-fab.module.css';
import { useAppSelector } from '@/app/lib/store/hooks';

export default function ScrollFab() {
  const isAtTop = useAppSelector(state => state.scroll.isAtTop);
  const isAtBottom = useAppSelector(state => state.scroll.isAtBottom);

  const container = document.getElementById('content-container');

  const scrollTo = (position: 'top' | 'bottom') => {
    if (container) {
      container.scrollTo({
        top: position === 'top' ? 0 : container.scrollHeight,
        behavior: 'smooth'
      });
    }
  };

  return (
    <ToggleGroup.Root
      className={styles.toggleGroupContainer}
      type='single'
      aria-label='Scroll actions'
    >
      {!isAtTop && (
        <motion.button
          className={styles.toggleButton}
          onClick={() => scrollTo('top')}
          whileTap={{ scale: 0.9 }}
          aria-label='Scroll to top'
        >
          <ChevronUpIcon />
        </motion.button>
      )}

      {!isAtBottom && (
        <motion.button
          className={styles.toggleButton}
          onClick={() => scrollTo('bottom')}
          whileTap={{ scale: 0.9 }}
          aria-label='Scroll to bottom'
        >
          <ChevronDownIcon />
        </motion.button>
      )}
    </ToggleGroup.Root>
  );
}
